var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.warningZone)?_c('div',[_vm._v(" deconnecter"),_c('span',{attrs:{"id":"SecondsUntilExpire"}},[_vm._v(_vm._s(_vm.IDLE_TIMEOUT)+" ")]),_vm._v(" seconds. ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }